import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SettingRoutingModule } from './setting.routing'
import { SettingComponent } from './setting.component'
import { StaffComponent } from './staff/staff.component'
import { ScrollbarModule } from 'ngx-scrollbar'
import { OnsenModule } from 'ngx-onsenui'
import { BehaviourSettingServices, SharedServices } from '../../../services'
import { ClinicComponent } from './clinic/clinic.component'
import { CommonComponent } from './common/common.component'
import { BehaviourComponent } from './behaviour/behaviour.component'
import { MailComponent } from './mail/mail.component'
import { DeviceComponent } from './device/device.component'
import { PaymentComponent } from './payment/payment.component'
import { PipeModule } from '../../../pipes/pipe.module'
import { DocumentComponent } from './document/document.component'
import { DragulaModule } from 'ng2-dragula'
@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        SettingRoutingModule,
        ReactiveFormsModule,
        ScrollbarModule,
        OnsenModule,
        PipeModule,
        DragulaModule.forRoot(),
    ],
    declarations: [
        SettingComponent,
        StaffComponent,
        ClinicComponent,
        CommonComponent,
        BehaviourComponent,
        MailComponent,
        DeviceComponent,
        PaymentComponent,
        DocumentComponent,
    ],
    providers: [
        SharedServices,
        BehaviourSettingServices,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
})
export class SettingModule {
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/setting/setting.module.ts